export const OperationKey = {
  STB_LOOK_LOG_INFO: 'stb-look-log-info', // 查看机顶盒日志信息
  STB_SET_LOG_CONFIG: 'stb-set-log-config', // 设置机顶盒日志配置
  WG_REMOTE_DESKTOP: 'wg-remote-desktop', // 网关远程桌面
  FY_REMOTE_DESKTOP: 'fy-remote-desktop', // 网关远程桌面
  FY_DELETE_REPEAT_SONGS: 'fy-delete-repeat-songs', // 锋云删除重复歌曲
};
